module.exports = __webpack_public_path__ + "media/components/assets/close_black-7275886ac7e84f180dfd4c00d62a1832.svg";